<button mat-flat-button (click)="reset()" class="mt-2">
    <mat-icon>refresh</mat-icon>
    Poništi promjene
</button>

<div class="mt-2 grid grid-cols-4 gap-4">
    <div>
        <p class="font-semibold text-lg">Uključeni</p>
        <mat-form-field>
            <input
                #elIn
                matInput
                placeholder="Pretraži"
                (input)="search(elIn.value, delaySearchIn)" />
        </mat-form-field>
        <cdk-virtual-scroll-viewport
            cdkDropList
            id="inList"
            #inListRef="cdkDropList"
            [cdkDropListData]="inList()"
            [cdkDropListConnectedTo]="[outListRef]"
            [cdkDropListSortingDisabled]="true"
            (cdkDropListDropped)="drop($event)"
            [itemSize]="itemSize"
            [minBufferPx]="1000"
            [maxBufferPx]="2000"
            class="h-[35rem] p-1 select-none">
            <div
                *cdkVirtualFor="let e of filterInList()"
                class="h-16 box-border"
                cdkDrag
                [cdkDragData]="e">
                <mat-card class="h-14 cursor-move">
                    <mat-card-content>{{ e.fullName }} ({{ e.mbrad }})</mat-card-content>
                </mat-card>
            </div>
        </cdk-virtual-scroll-viewport>
    </div>
    <div>
        <p class="font-semibold text-lg">Isključeni</p>
        <mat-form-field>
            <input
                #elOut
                matInput
                placeholder="Pretraži"
                (input)="search(elOut.value, delaySearchOut)" />
        </mat-form-field>
        <cdk-virtual-scroll-viewport
            cdkDropList
            id="outList"
            #outListRef="cdkDropList"
            [cdkDropListData]="outList()"
            [cdkDropListConnectedTo]="[inListRef]"
            [cdkDropListSortingDisabled]="true"
            (cdkDropListDropped)="drop($event)"
            [itemSize]="itemSize"
            [minBufferPx]="1000"
            [maxBufferPx]="2000"
            class="h-[35rem] p-1 select-none">
            <div
                *cdkVirtualFor="let e of filterOutList()"
                class="h-16 box-border"
                cdkDrag
                [cdkDragData]="e">
                <mat-card class="h-14 cursor-move">
                    <mat-card-content>{{ e.fullName }} ({{ e.mbrad }})</mat-card-content>
                </mat-card>
            </div>
        </cdk-virtual-scroll-viewport>
    </div>
    <div>
        <p class="font-semibold text-lg ml-1">Zauvijek uključeni</p>
        <mat-form-field>
            <input
                #elAin
                matInput
                placeholder="Pretraži"
                (input)="search(elAin.value, delaySearchAin)" />
        </mat-form-field>
        <cdk-virtual-scroll-viewport
            [itemSize]="alwaysItemSize"
            [minBufferPx]="1000"
            [maxBufferPx]="2000"
            class="h-[35rem]">
            <div *cdkVirtualFor="let e of filterAlwaysIncluded()" class="h-14 box-border px-1">
                {{ e.fullName }} ({{ e.mbrad }})
            </div>
        </cdk-virtual-scroll-viewport>
    </div>
    <div>
        <p class="font-semibold text-lg ml-1">Zauvijek isključeni</p>
        <mat-form-field>
            <input
                #elAout
                matInput
                placeholder="Pretraži"
                (input)="search(elAout.value, delaySearchAout)" />
        </mat-form-field>
        <cdk-virtual-scroll-viewport
            [itemSize]="alwaysItemSize"
            [minBufferPx]="1000"
            [maxBufferPx]="2000"
            class="h-[35rem]">
            <div *cdkVirtualFor="let e of filterAlwaysExcluded()" class="h-14 box-border px-1">
                {{ e.fullName }} ({{ e.mbrad }})
            </div>
        </cdk-virtual-scroll-viewport>
    </div>
</div>
